export default __webpack_public_path__ + "static/media/any.46dcf9bb.svg";